export const ROUTE_BY_KIND = {
  purchase_order: "stock-purchase-orders-view",
  sales_order: "stock-sales-orders-view",
  receipt: "stock-receipts-view",
  delivery: "stock-sales-view",
  delivery_note: "stock-delivery-notes-view",
  transport_order: "stock-transport-orders-view",
  invoice: "stock-invoices-view",
};

export const KIND_META = {
  sales_order: {
    label: "SO",
    icon: "mdi-cart-outline",
    variant: "sales-order",
  },
  purchase_order: {
    label: "PO",
    icon: "mdi-clipboard-text-outline",
    variant: "purchase-order",
  },
  transport_order: {
    label: "TO",
    icon: "mdi-airplane",
    variant: "transport",
  },
  receipt: {
    label: "Receipt",
    icon: "mdi-package-down",
    variant: "receipt",
  },
  delivery: {
    label: "Delivery",
    icon: "mdi-truck-delivery",
    variant: "delivery",
  },
  delivery_note: {
    label: "DN",
    icon: "mdi-note-text",
    variant: "delivery-note",
  },
  invoice: {
    label: "INV",
    icon: "mdi-file-document-outline",
    variant: "invoice",
  },
};

export const LINK_SLOTS = [
  "sales_order",
  "purchase_order",
  "delivery_note",
  "invoice",
];

export function nodeRoute(item) {
  const name = ROUTE_BY_KIND[item.kind || item.document_kind];
  if (!name) {
    return {};
  }
  return { name, params: { id: item.id } };
}

export function kindLabel(kind) {
  return KIND_META[kind]?.label || kind;
}

export function kindIcon(kind) {
  return KIND_META[kind]?.icon || "mdi-file-document-outline";
}

export function kindVariant(kind) {
  return KIND_META[kind]?.variant || "default";
}

export function countTreeNodes(nodes) {
  if (!Array.isArray(nodes) || !nodes.length) {
    return 0;
  }

  return nodes.reduce((total, node) => {
    const childCount = countTreeNodes(node.children || []);
    return total + 1 + childCount;
  }, 0);
}

export function formatFileSize(sizeInBytes) {
  const size = Number(sizeInBytes);
  if (!Number.isFinite(size) || size <= 0) {
    return "0 B";
  }
  const units = ["B", "KB", "MB", "GB"];
  let value = size;
  let unitIndex = 0;
  while (value >= 1024 && unitIndex < units.length - 1) {
    value /= 1024;
    unitIndex += 1;
  }
  return `${value.toFixed(unitIndex === 0 ? 0 : 1)} ${units[unitIndex]}`;
}
